import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { PATH_PAGE } from '~/routes/paths';
import LoadingScreen from '~/components/LoadingScreen';

// ----------------------------------------------------------------------

AuthProtect.propTypes = {
  children: PropTypes.node
};

function AuthProtect({ children }) {
  // const { auth } = useSelector(state => state.user);
  const { auth } = useSelector(state => state.user);
  console.log("auth", auth)

  console.log("AuthProtect")
  // if (!isLoaded(auth)) {
  //   return <LoadingScreen />;
  // }


  const token = localStorage.getItem("token");
  console.log(token)

  //  if (isEmpty(auth)) {
  if (token == null) {
    return <Redirect to={PATH_PAGE.auth.login} />;
  }

  return children;
}

export default AuthProtect;
